import type { ServiceProvider, ServiceContainer } from "../service-container";
import type { ImageAdapterFactoriesPool } from "./ImageAdapterFactoriesPool";
import { BasePool } from "../pool";
import { CanvasFactory } from "./CanvasFactory";
import { BaseImageAdapterResolver } from "./BaseImageAdapterResolver";

/**
 * Image adapter service provider.
 * @internal
 */
export const imageAdapterProvider: ServiceProvider = {
  /**
   * Registers entities, related to image adapter, in service container.
   *
   * @param container
   */
  register(container: ServiceContainer) {
    const pool: ImageAdapterFactoriesPool = new BasePool();
    pool.add("BrowserCanvas", new CanvasFactory());
    container.register("ImageAdapterFactoriesPool", pool);

    container.register("ImageAdapterResolver", (c) => {
      return new BaseImageAdapterResolver(
        c.resolve("ImageAdapterFactoriesPool")
      );
    });
  },
};
